import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { NotificationsService } from "angular2-notifications";

import { SharedCommonService } from "app/shared/shared-common.service";
import { SecurityService } from "app/security/security.service";
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	Username: string = "";
	Password: string = "";

	ForgottenEmail: string = "";
	ForgottenPassword: boolean = false;
	loginForm;
    forgottenPasswordForm;

    LoginSubscription: Subscription;

    constructor(private securityService: SecurityService, private commonService: SharedCommonService, private router: Router, private _notification: NotificationsService) { }

	ngOnInit(): void {
		setTimeout(() => {
		    this.commonService.setVariable("FullScreen", true);
		}, 50);
	};
	ngOnDestroy(): void {
        this.commonService.setVariable("FullScreen", false);
        if (this.LoginSubscription != null) {
            this.LoginSubscription.unsubscribe();
        }
	};

	GoToLogin() {
		this.ForgottenPassword = false;
	};

	GoToForgottenPassword() {
		this.ForgottenPassword = true;
    };

    Login() {
        this.LoginSubscription = this.securityService.Login(this.Username, this.Password).subscribe(data => {
            if (data instanceof ErrorObservable) {
                this._notification.error("Login Error", data.error);
            } else {
                this._notification.success("Login Success", "User Login Successful");
                this.router.navigate(['/dashboard']);
            }
        }, err => {
            this._notification.error("Login Error", "User Login Not Successful");
            console.log(err)
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/security/login/login.component.ts